/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';

import { Colors, Spacing, TypographyStyles } from 'src/common/ui/base';

export const formControlStyles = css`
  display: block;
  margin-bottom: ${Spacing.Unit4}px;
`;

export const inputStyles = css`
  width: 100%;
`;

export const errorStyles = css`
  ${TypographyStyles.caption};
  color: ${Colors.Red3};
  text-transform: capitalize;
`;
